// Copyright ©️ 2026 eVolve MEP, LLC

import { Text, Title } from '@mantine/core';

import type { ALL_MODULE_ROUTES } from 'app/ModuleRoutes';
import { isKeyOf } from 'helpers/isKeyOf';

import { pageSpecificWelcomeScreens, welcomeScreenRouteAliases } from './constants';
import { WelcomeModal } from './WelcomeModal';

type Props = {
  route: keyof typeof ALL_MODULE_ROUTES;
};

export const RouteBasedWelcomeModal = ({ route }: Props) => {
  // '/fabrication' only redirects, so its welcome screen is shown by the route it redirects to.
  if (route === '/fabrication') return null;
  const welcomeScreenRoute = isKeyOf(route, welcomeScreenRouteAliases) ? welcomeScreenRouteAliases[route] : route;
  if (!isKeyOf(welcomeScreenRoute, pageSpecificWelcomeScreens)) return null;
  const { image, title, description } = pageSpecificWelcomeScreens[welcomeScreenRoute];
  return (
    <WelcomeModal featureName={welcomeScreenRoute}>
      <img
        src={image}
        alt={`${title} example`}
        style={{ maskImage: 'linear-gradient(to bottom, black 55%, transparent 100%)' }}
      />
      <Title order={2}>{title}</Title>
      <Text>{description}</Text>
    </WelcomeModal>
  );
};
